import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../axios/axionInstance';
import { responseHandler } from '../utils';

type MutationParams = {
    id: string | number;
};

export const useCreatePoi = (
  options?: UseMutationOptions<void, AxiosError, MutationParams>,
): UseMutationResult<void, AxiosError, MutationParams> => useMutation<void, AxiosError, MutationParams>({
  mutationFn: ({ id }) => axiosInstance.post(`/v3-CreatePOIsList?hotelId=${id}`, {
    headers: { 'Content-Type': 'application/json' },
  }).then(responseHandler),
  ...options,
});
